import { translate } from '@gig/magic-common';
import { ValidationDisplay, required, minLength, maxLength } from '@gig/magic-form-builder';

function username() {
    return {
        id: 'username',
        component: 'magic-ui-form-field',
        isDataField: true,
        type: 'text',
        testId: 'username',
        properties: {
            placeholder: translate('login.corex.username.placeholder'),
        },
        validationDisplay: ValidationDisplay.OnTouchShowMessage,
        validation: [
            {
                name: 'required',
                fn: required,
                message: translate('login.corex.username.required.error'),
            },
            {
                name: 'min-length',
                fn: minLength(2),
                message: translate('sign-up-step-one.username-corex.length.error'),
            },
            {
                name: 'max-length',
                fn: maxLength(50),
                message: translate('sign-up-step-one.username-corex.length.error'),
            },
        ],
    };
}

export { username };
